import type { components } from "@/shared/api";

type MatchSummary = components["schemas"]["MatchSummary"];

export type Streak = {
  won: boolean;
  // Матчи серии, новые сверху.
  matches: MatchSummary[];
};

// Текущая серия: подряд идущие победы или поражения, начиная с последнего матча.
// `matches` — новые сверху, как в `GET /api/matches`. Матчей нет — `null`.
export const currentStreak = (matches: readonly MatchSummary[]): Streak | null => {
  const [latest] = matches;
  if (latest === undefined) {
    return null;
  }
  const end = matches.findIndex((match) => match.won !== latest.won);
  return { won: latest.won, matches: matches.slice(0, end === -1 ? matches.length : end) };
};
